import { withResourceRecords } from '@/shared/contexts'
import { Screen } from '@/shared/ui/Layout'

import { WalletExtractHero } from './components/WalletExtractHero'
import { WalletMovementsEmpty } from './components/WalletMovementsEmpty'
import { WalletMovementsInfiniteList } from './components/WalletMovementsInfiniteList'
import { WalletMovementsListSkeleton } from './components/WalletMovementsListSkeleton'
import { getConfig } from './config'
import { useWalletExtractView } from './hooks/useWalletExtractView'

const WalletMovementsPage = () => {
  const {
    wallet,
    movements,
    isLoading,
    isEmpty,
    isReachingEnd,
    size,
    setSize,
    humanName
  } = useWalletExtractView()

  const showInitialSkeleton = isLoading && movements.length === 0

  return (
    <Screen>
      <Screen.Context>
        <WalletExtractHero title={humanName.plural} wallet={wallet} />
      </Screen.Context>

      <Screen.Content className="pt-4">
        {showInitialSkeleton ? (
          <WalletMovementsListSkeleton />
        ) : isEmpty ? (
          <WalletMovementsEmpty />
        ) : (
          <WalletMovementsInfiniteList
            movements={movements}
            isLoading={isLoading}
            isReachingEnd={isReachingEnd}
            size={size}
            setSize={setSize}
          />
        )}
      </Screen.Content>
    </Screen>
  )
}

export const DigitalProductWalletMovements = withResourceRecords(
  WalletMovementsPage,
  getConfig
)
